// English — canonical resource. Other locales mirror this structure.
const en = {
  common: {
    by: "by Wadiah Mutual",
    pronounced: "pronounced \u201cROAM\u201d",
    getQuote: "Get My Quote",
    explorePlans: "Explore R0AM Plans",
    explorePlansShort: "Explore Plans",
    viewAllPlans: "View all plans",
    requestQuote: "Request Quote",
    buildPlan: "Build My R0AM Plan",
    continue: "Continue",
    back: "Back",
    bestFor: "Best for",
    recommendedPlan: "Recommended plan",
    startingPrice: "Starting price subject to plan, age, country of residence, destination, and terms.",
    home: "Home",
    contactCta: "Contact R0AM",
    sendMessage: "Send Message",
  },
  nav: {
    plans: "Plans",
    smartbag: "SmartBag",
    telemedicine: "Telemedicine",
    connectivity: "Connectivity",
    riskOptions: "Risk Options",
    traders: "Traders",
    partners: "Partners",
    compliance: "Compliance",
    faq: "FAQ",
    contact: "Contact",
  },
  langName: "English",
  hero: {
    badge: "Global mobility membership",
    titleA: "Your life does not fit into a",
    titleAccent: "one-trip policy.",
    subtitle: "R0AM by Wadiah Mutual is global mobility assistance for people who work, travel, trade, relocate, attend conferences, and return home in cycles.",
    route: "Portugal → UAE → Thailand → Vietnam → Home · designed for people who don't live their year in one country.",
  },
  shift: {
    overline: "The Mobility Shift",
    title: "The world no longer travels in straight lines.",
    oldModel: "Old model",
    oldNodes: ["Home", "Vacation", "Home"],
    oldDesc: "A single trip, a single policy, a single return. Built for a way of living most global people left behind.",
    newModel: "R0AM model",
    newNodes: ["Home", "Work Country", "Low-Cost Living Hub", "Conference Hub", "Family / Home Country", "Next Destination"],
    newDesc: "Recurring, multi-country, cyclical. One protection structure that moves with you instead of resetting at every border.",
  },
  who: {
    overline: "Who R0AM Is For",
    title: "Built for the way global people actually live.",
  },
  cycles: {
    overline: "Choose Your R0AM Cycle",
    title: "Your year already has a pattern. We built plans around it.",
    whoServes: "Who it serves",
    mainRisks: "Main risks",
  },
  pillars: {
    overline: "Product Pillars",
    title: "One platform for modern global movement.",
    complianceNote: "Compliance note: R0AM includes a defined benefit for pre-existing conditions where available, subject to limits, terms, exclusions, and general conditions of the selected plan. We never claim full pre-existing condition coverage.",
  },
  homePlans: {
    overline: "R0AM Plans",
    title: "One protection structure. Built around your cycle.",
  },
  finalCta: {
    title: "Move between countries without rebuilding your protection every time.",
    subtitle: "R0AM by Wadiah Mutual \u2014 {{pronounced}}. Designed for people who don't live their year in one country.",
  },
  plansPage: {
    overline: "R0AM Plans",
    titleA: "Choose the structure that",
    titleAccent: "moves with you.",
    subtitle: "No fixed pricing yet \u2014 each plan is tailored to your cycle, destinations, and household. Request a quote and we'll build it with you.",
    banner: "Availability, benefits, limits, exclusions, and pricing depend on the selected plan, destination, age, country of residence, and official wording. R0AM includes a defined benefit for pre-existing conditions where available, subject to limits, terms, exclusions, and general conditions of the selected plan.",
    ctaTitle: "Not sure which plan fits your year?",
    ctaSub: "Tell us how you move and we'll recommend the right R0AM structure.",
  },
  quote: {
    step: "Step",
    s1Title: "Who are you?",
    s1Hint: "This helps us route your request correctly.",
    s2Title: "Where are you moving?",
    s2Hint: "Give us your route for the next 12 months.",
    currentCountry: "Current country",
    currentPh: "e.g. Portugal",
    nextDestination: "Next destination",
    nextPh: "e.g. UAE",
    countries12: "Countries expected in next 12 months",
    countriesPh: "Add a country and press Enter",
    s3Title: "Who needs assistance?",
    travelerCount: "Number of travelers",
    travelerCountPh: "e.g. 4",
    s4Title: "What do you need?",
    s4Hint: "Select everything that applies.",
    s5Title: "Contact details",
    name: "Name",
    email: "Email",
    whatsapp: "WhatsApp",
    residence: "Country of residence",
    startDate: "Preferred start date",
    notes: "Notes",
    notesPh: "Anything we should know?",
    s6Title: "Compliance acknowledgement",
    ack1: "I understand that availability, benefits, limits, exclusions, and pricing depend on the selected plan, destination, age, country of residence, and official wording.",
    ack2: "I understand that pre-existing condition benefits, where available, are limited and subject to plan wording.",
    submit: "Submit Quote Request",
    footnote: "R0AM is {{pronounced}} · your details are used only to prepare your quote.",
    planLabel: "Plan",
    successTitle: "Quote request received.",
    successBody: "Thank you, {{name}}. Our team will review your R0AM mobility profile and reach out {{channel}} shortly.",
    onWhatsapp: "on WhatsApp",
    byEmail: "by email",
    traveler: "traveler",
    assistedTitle: "Routed to assisted review",
    assistedBody: "Because you indicated interest in a pre-existing condition benefit, your request goes to a specialist rather than instant checkout, so we can confirm available limits and terms.",
    demoNote: "Demo mode: payload logged to console, ready for mutualautomation.",
    backHome: "Back to home",
    explore: "Explore plans",
    segments: {
      digital_nomad: "Digital nomad",
      seasonal_worker: "Seasonal worker",
      trader_conference: "Trader / conference traveler",
      relocation: "Relocation client",
      family: "Family",
      executive_hnw: "Executive / HNW group",
      partner_agency: "Partner / agency",
    },
    travelers: {
      individual: "Individual",
      couple: "Couple",
      family: "Family",
      group: "Group",
      entourage: "Entourage / staff",
    },
    needs: {
      travel_assistance: "Travel assistance",
      smartbag: "SmartBag",
      telemedicine: "Telemedicine",
      connectivity: "Connectivity",
      risk_options: "Risk options",
      monthly_payment: "Monthly payment",
      pre_existing: "Defined pre-existing condition benefit",
    },
    errSegment: "Please select who you are.",
    errCurrent: "Please tell us your current country.",
    errTraveler: "Please select who needs assistance.",
    errNeeds: "Select at least one need.",
    errName: "Name is required.",
    errEmail: "Valid email is required.",
    errResidence: "Country of residence is required.",
    errAck: "Please confirm both acknowledgements.",
  },
  smartbag: {
    overline: "SmartBag",
    titleA: "When your luggage does not",
    titleAccent: "follow your route.",
    subtitle: "SmartBag is the simple entry point into R0AM. It supports travelers when luggage is delayed, lost, misrouted, mishandled, or becomes a travel disruption.",
    featOverline: "What SmartBag covers",
    featTitle: "Support for every way baggage goes wrong.",
    features: [
      { title: "Delayed baggage", desc: "Support while your bag catches up to your route." },
      { title: "Lost baggage", desc: "Coordination and documentation when a bag doesn't arrive." },
      { title: "Misrouted luggage", desc: "Help when your bag takes a different itinerary than you." },
      { title: "Emergency replacement support", desc: "Essentials assistance while you wait." },
      { title: "Airline documentation", desc: "Guidance on PIR and claim paperwork." },
      { title: "Assistance coordination", desc: "One point of contact across airlines and airports." },
    ],
    banner: "SmartBag benefits are subject to limits and documentation requirements. Coverage is subject to the official plan terms and conditions of the selected plan.",
    ctaTitle: "Add SmartBag to your R0AM plan.",
    ctaSub: "Start with SmartBag, then layer assistance, telemedicine, connectivity, and risk options as your year requires.",
    ctaLabel: "Add SmartBag to My R0AM Plan",
  },
  telemedicine: {
    overline: "Telemedicine",
    titleA: "Medical support wherever your",
    titleAccent: "route takes you.",
    subtitle: "R0AM can include telemedicine access and digital triage tools that help the medical team evaluate the case faster.",
    flowOverline: "How it works",
    flowTitle: "From request to coordinated care.",
    steps: [
      { title: "User requests support", desc: "Reach the assistance desk from anywhere." },
      { title: "Digital triage", desc: "Triage tools help structure the case quickly." },
      { title: "Medical team review", desc: "A medical professional evaluates the situation." },
      { title: "Recommendation", desc: "Home doctor, clinic, or hospital coordination." },
    ],
    banner: "Telemedicine and digital triage are support tools and do not replace emergency medical services. Facial or digital triage tools are not an automatic diagnosis \u2014 they help the medical team evaluate a case faster. Availability is subject to the selected plan and provider terms.",
    ctaTitle: "Carry your medical support across borders.",
    ctaSub: "Add telemedicine to your R0AM plan and keep one medical point of contact all year.",
  },
  connectivity: {
    overline: "Connectivity · Coming soon",
    titleA: "Stay connected while",
    titleAccent: "you move.",
    subtitle: "R0AM is designed to support future global connectivity options, including eSIM, roaming data, international communication tools, and mobile continuity for travelers who work across borders.",
    featOverline: "Possible features",
    featTitle: "Communication continuity, everywhere your year goes.",
    features: [
      { title: "eSIM activation", desc: "Spin up local data the moment you land." },
      { title: "Data top-ups", desc: "Flexible top-ups for longer stays." },
      { title: "Roaming support", desc: "Stay reachable across regions." },
      { title: "Travel alerts", desc: "Region and route notifications." },
      { title: "Emergency contact access", desc: "Reach assistance fast." },
      { title: "WhatsApp support", desc: "Talk to the desk where you already are." },
      { title: "Corporate traveler connectivity", desc: "For teams moving together." },
    ],
    ctaTitle: "Be first when R0AM Connectivity launches.",
    ctaSub: "Join the waitlist and we'll notify you as eSIM and roaming options become available.",
    ctaLabel: "Join Connectivity Waitlist",
  },
  risk: {
    overline: "Risk Options",
    titleA: "For trips where assistance needs to",
    titleAccent: "go further.",
    subtitle: "Some travelers need more than ordinary assistance. R0AM can support optional risk-management tiers through approved partners, including higher-support options for executives, HNW travelers, groups, remote regions, and complex travel.",
    featOverline: "Higher-support tiers",
    featTitle: "Optional risk management through approved partners.",
    features: [
      { title: "Emergency coordination", desc: "A coordinated response when situations escalate." },
      { title: "Evacuation options where available", desc: "Medical or security evacuation through partners." },
      { title: "Crisis support options", desc: "Structured support during disruptive events." },
      { title: "Corporate traveler monitoring", desc: "Visibility for teams on the move." },
      { title: "Regional risk alerts", desc: "Stay ahead of changing conditions." },
      { title: "High-risk destination review", desc: "Pre-travel assessment for complex routes." },
    ],
    banner: "Availability, scope, and response depend on the selected partner, plan, destination, and contract terms. War, conflict, sanctions, restricted territories, and related events may be excluded.",
    ctaTitle: "Build a plan that goes further.",
    ctaSub: "Tell us about your routes and we'll structure the right risk tier with our partners.",
  },
  traders: {
    overline: "Traders & Conferences",
    titleA: "Built for the",
    titleAccent: "conference economy.",
    subtitle: "Crypto, forex, fintech, payments, and trading professionals often move between Dubai, Singapore, Limassol, Lisbon, Bangkok, Miami, Panama, and London. Their travel is not leisure. It is part of their business infrastructure.",
    circuitOverline: "The circuit",
    flowOverline: "Your workflow",
    flowTitle: "R0AM works before, during, and after every event.",
    steps: [
      { title: "Before event", desc: "Quote + plan + SmartBag + connectivity." },
      { title: "During event", desc: "WhatsApp support + baggage help + telemedicine + risk alerts." },
      { title: "After event", desc: "Next destination + renewal + upgrade." },
      { title: "Group plans", desc: "Bring your team onto one structure." },
    ],
    ctaTitle: "Make travel part of your edge, not your risk.",
    ctaSub: "Build a conference-circuit plan that follows your calendar across every city.",
    ctaLabel: "Build My Conference Travel Plan",
  },
  seasonal: {
    overline: "Seasonal Workers",
    titleA: "Built around the real",
    titleAccent: "work-rest-home cycle.",
    subtitle: "Many seasonal workers earn in Australia or New Zealand, reset in Thailand or Vietnam, return home for holidays, and repeat the cycle. R0AM is designed for that pattern.",
    cycleOverline: "Your cycle",
    cycleTitle: "One structure that follows the season.",
    cycle: ["Australia / NZ (work)", "Thailand / Vietnam (reset)", "Home country (holidays)", "Back to work"],
    ctaTitle: "Protection that resets with you, not against you.",
    ctaSub: "Monthly payment options and multi-country routing built for the seasonal pattern.",
    ctaLabel: "Build My Seasonal Worker Plan",
  },
  partners: {
    overline: "Partners",
    titleA: "Partner with",
    titleAccent: "R0AM.",
    subtitle: "Bring R0AM global mobility assistance to your clients and community. We work with the organizations that already guide how global people move.",
    whoTitle: "Who we partner with",
    whoDesc: "R0AM becomes the protection layer beneath your service \u2014 quote routing, CRM-ready leads, WhatsApp follow-up, and a partner pipeline designed to scale with you.",
    targets: ["Visa agencies", "Relocation firms", "Digital nomad communities", "Coworking spaces", "Coliving operators", "Forex brokers", "Crypto communities", "Conference organizers", "Travel agencies", "Family offices", "Concierge providers", "Study/work abroad agencies", "Corporate mobility teams"],
    types: ["Visa agency", "Relocation firm", "Digital nomad community", "Coworking space", "Coliving operator", "Forex broker", "Crypto community", "Conference organizer", "Travel agency", "Family office", "Concierge provider", "Study/work abroad agency", "Corporate mobility team"],
    fCompany: "Company name",
    fContact: "Contact person",
    fEmail: "Email",
    fWhatsapp: "WhatsApp",
    fWebsite: "Website",
    fCountry: "Country",
    fType: "Partner type",
    fSelect: "Select\u2026",
    fVolume: "Estimated monthly volume",
    fVolumePh: "e.g. 50 leads / month",
    fMarkets: "Markets served",
    fMarketsPh: "e.g. UAE, Portugal, SE Asia",
    fProducts: "Interested products",
    fNotes: "Notes",
    submit: "Become a R0AM Partner",
    products: ["Global Mobility Assistance", "SmartBag", "Telemedicine", "Connectivity", "Risk Options"],
    successTitle: "Thanks, {{name}}.",
    successBody: "Our partnerships team will reach out to {{company}} shortly.",
    errRequired: "Company and contact person are required.",
    errEmail: "A valid email is required.",
    errType: "Please select a partner type.",
    successToast: "Partnership request received.",
  },
  compliance: {
    overline: "Compliance",
    title: "How R0AM is positioned.",
    subtitle: "Transparency is part of the membership. Here's exactly what R0AM by Wadiah Mutual is \u2014 and what each service is subject to.",
    positioning: "R0AM by Wadiah Mutual is a travel assistance and global mobility distribution brand. Coverage and services are subject to the selected plan, terms, limits, exclusions, provider availability, and official contract wording. Wadiah Mutual is not represented as the insurer unless legally approved.",
    disclaimersTitle: "Required disclaimers",
    disclaimers: [
      "Coverage is subject to official plan terms and conditions.",
      "Pre-existing condition benefits, where available, are limited.",
      "War, conflict, sanctions, restricted territories, and related events may be excluded.",
      "Telemedicine and digital triage do not replace emergency medical services.",
      "SmartBag benefits are subject to limits and documentation requirements.",
      "Risk management options depend on partner terms and destination.",
      "Availability may vary by country of residence, destination, age, plan, and underwriting or provider rules.",
    ],
    banner: "We never claim full pre-existing condition coverage. R0AM includes a defined benefit for pre-existing conditions where available, subject to limits, terms, exclusions, and general conditions of the selected plan. Leads disclosing pre-existing conditions are routed to assisted review, not instant checkout.",
    ctaTitle: "Questions about coverage and terms?",
    ctaSub: "Our team will walk you through exactly what applies to your plan and destinations.",
  },
  faqPage: {
    overline: "FAQ",
    title: "Questions, answered.",
    subtitle: "R0AM is {{pronounced}}. Here's how the membership works and what each part is subject to.",
    ctaTitle: "Still have a question?",
    ctaSub: "Talk to the R0AM team and we'll help you structure the right plan.",
  },
  contact: {
    overline: "Contact",
    title: "Talk to R0AM.",
    subtitle: "Tell us how you move and we'll help structure the right global mobility plan.",
    reachUs: "Reach us directly",
    whatsappSupport: "WhatsApp support",
    note: "R0AM is {{pronounced}}. Global mobility assistance by Wadiah Mutual.",
    fName: "Name",
    fEmail: "Email",
    fWhatsapp: "WhatsApp",
    fMessage: "Message",
    successTitle: "Message sent.",
    successBody: "We'll be in touch with {{name}} shortly.",
    demoNote: "Demo mode: payload logged to console.",
    errName: "Name is required.",
    errEmail: "A valid email is required.",
    errMessage: "Please add a message.",
    sentToast: "Message sent.",
  },
  footer: {
    tagline: "Global mobility assistance for people who don't live their year in one country. Assistance, connectivity, baggage support, telemedicine, and risk options for modern global movement.",
    pronouncedLine: "R0AM is {{pronounced}}",
    colPlatform: "Platform",
    colWho: "Who It's For",
    colTrust: "Trust",
    reachUs: "Reach Us",
    whatsappSupport: "WhatsApp support",
    newsletterPh: "Email for mobility updates",
    newsletterErr: "Please enter a valid email address.",
    newsletterOk: "You're on the list. We'll be in touch.",
    disclaimer: "R0AM by Wadiah Mutual is a travel assistance and global mobility distribution brand. Coverage and services are subject to the selected plan, terms, limits, exclusions, provider availability, and official contract wording.",
    seeCompliance: "See compliance notes",
  },
  chatbot: {
    launcher: "Mobility Assistant",
    title: "R0AM Mobility Assistant",
    online: "Online · replies instantly",
    intro: "Hi, I'm the R0AM Mobility Assistant. I can help you find the right global mobility assistance plan based on where you live, where you are going, and how you move through the year.",
    askLanguage: "First, which language do you prefer?",
    askSegment: "What best describes you?",
    askResidence: "Which country do you live in?",
    askCurrent: "Which country are you in right now?",
    askNext: "Where are you heading next?",
    askCountries: "Which countries do you expect in the next 12 months? (comma separated)",
    askTravelers: "How many travelers need assistance?",
    askAge: "Which age ranges apply? (select all)",
    askCycle: "Which travel cycle fits you best?",
    askPlan: "Which plan interests you most?",
    askNeeds: "What do you need? (select all)",
    askPreExisting: "Do you need to disclose a pre-existing medical condition?",
    askPayment: "Annual or monthly payment?",
    askName: "What's your name?",
    askEmail: "Your email?",
    askWhatsapp: "Your WhatsApp number?",
    yes: "Yes",
    no: "No",
    annual: "Annual",
    monthly: "Monthly",
    next: "Next",
    typePlaceholder: "Type your answer…",
    compliance: "R0AM provides global mobility assistance and travel-assistance distribution. Availability, benefits, pricing, limits, exclusions, and services depend on the selected plan, provider terms, country of residence, age, destination, and official wording. Pre-existing condition benefits, where available, are limited and subject to plan terms.",
    doneTitle: "Thank you — your intake is ready.",
    doneBody: "I've prepared your R0AM mobility profile. Our team will follow up shortly.",
    assistedNote: "Your request will go to assisted review so a specialist can confirm available limits and terms.",
    highValueNote: "You've been flagged as a priority profile — expect a fast, dedicated response.",
    fallback: "Prefer to talk to a person?",
    fallbackCta: "Contact the R0AM team",
    restart: "Start over",
    demoNote: "Demo mode: intake logged, ready for mutualautomation.",
  },
  data: {
    segments: {
      nomads: { title: "Digital Nomads", desc: "Portugal today. Thailand next month. Home for the holidays." },
      seasonal: { title: "Seasonal Workers", desc: "Australia for work. Vietnam to reset. South America for family. Then back again." },
      traders: { title: "Traders & Conference Travelers", desc: "Dubai, Singapore, Limassol, Lisbon, Miami \u2014 your calendar is global." },
      relocation: { title: "Relocation Clients", desc: "A soft landing while your residency, housing, banking, connectivity, and local coverage are being organized." },
      families: { title: "Global Families", desc: "One year. Several countries. One protection structure." },
      hnw: { title: "HNW & Entourage", desc: "For families, assistants, staff, drivers, nannies, security teams, and frequent travel groups." },
    },
    pillars: {
      assistance: { title: "Global Mobility Assistance", desc: "Annual and multi-country assistance for recurring international movement." },
      smartbag: { title: "SmartBag", desc: "Support when luggage is delayed, lost, misrouted, mishandled, or does not follow your route." },
      telemedicine: { title: "Telemedicine", desc: "Remote medical guidance and triage support wherever your year takes you." },
      connectivity: { title: "Connectivity", desc: "Future connectivity and MVNO-style options for eSIM, data, roaming, and communication continuity." },
      risk: { title: "Risk Options", desc: "Optional risk management, rescue, evacuation, and higher-support tiers through approved partners where available." },
      preexisting: { title: "Defined Pre-Existing Condition Benefit", desc: "Includes a defined benefit for pre-existing conditions where available, subject to limits, terms, exclusions, and general conditions of the selected plan." },
    },
    plans: {
      essential: { name: "R0AM Essential", tagline: "For simple recurring international travel.", bestFor: "Occasional cross-border travelers who still move in cycles.", features: ["Annual multi-trip assistance", "24/7 travel coordination", "SmartBag baggage support (optional)", "Telemedicine guidance access"] },
      nomad: { name: "R0AM Nomad", tagline: "For remote workers and long-stay travelers.", bestFor: "Digital nomads living months at a time across countries.", features: ["Long-stay multi-country assistance", "Telemedicine + digital triage", "Connectivity / eSIM options", "SmartBag included"] },
      plus: { name: "R0AM Plus", tagline: "For frequent travelers who want higher assistance features.", bestFor: "High-frequency flyers needing broader support tiers.", features: ["Enhanced assistance limits", "Priority coordination desk", "Risk option add-ons", "Defined pre-existing benefit where available"] },
      trader: { name: "R0AM Trader", tagline: "For crypto, forex, fintech, payments, broker, and conference travelers.", bestFor: "Professionals on the global conference circuit.", features: ["Conference-circuit routing", "WhatsApp support during events", "Baggage + connectivity priority", "Regional risk alerts"] },
      seasonal: { name: "R0AM Seasonal", tagline: "For seasonal workers moving between work countries, hubs, and home.", bestFor: "Work-rest-home cycle travelers.", features: ["Work-country to home-country routing", "Monthly payment preference", "Telemedicine access", "Low-cost hub coverage windows"] },
      family: { name: "R0AM Family", tagline: "For families moving across multiple countries through the year.", bestFor: "International families on one protection structure.", features: ["Multi-member, multi-country structure", "Children & dependants support", "Telemedicine for the household", "SmartBag for the group"] },
      black: { name: "R0AM Black", tagline: "For HNW travelers, groups, staff, and entourage.", bestFor: "Executives, families, assistants, drivers, nannies, security teams.", features: ["Entourage & staff travel groups", "Higher-support risk tiers", "Dedicated coordination", "Evacuation options where available"] },
    },
    cycles: {
      A: { label: "Southern Reset Loop", serves: "Seasonal workers and long-stay nomads earning abroad and resetting in low-cost hubs.", risks: "Gaps between work countries, baggage on multi-leg routes, healthcare continuity.", route: ["South America", "Australia / NZ", "Thailand / Vietnam", "Home Country", "Australia / NZ"] },
      B: { label: "Atlantic\u2013Gulf\u2013Asia", serves: "Remote workers and traders splitting the year between Europe, the Gulf and Asia.", risks: "Visa transitions, connectivity between regions, telemedicine across time zones.", route: ["Portugal", "UAE", "Thailand / Vietnam", "Home Country"] },
      C: { label: "Transatlantic Family", serves: "Global families and relocation clients moving across the Atlantic each year.", risks: "Multi-member coordination, dependants' health, schooling-season travel.", route: ["Europe / Canada", "Caribbean", "Latin America", "Europe / Canada"] },
      D: { label: "Gulf\u2013Europe\u2013Asia", serves: "Executives and HNW travelers with a recurring three-region calendar.", risks: "High-value travel, entourage logistics, premium assistance expectations.", route: ["UAE", "Europe", "Asia", "Home Country"] },
      E: { label: "Crypto / Forex Conference Circuit", serves: "Crypto, forex, fintech and payments professionals on the global event circuit.", risks: "Back-to-back events, baggage disruption, on-the-ground support during conferences.", route: ["Dubai", "Singapore", "Limassol", "Lisbon", "Miami", "Panama"] },
    },
    faqs: [
      { q: "How is R0AM pronounced?", a: "R0AM is pronounced \u201cROAM.\u201d The stylized zero represents a protected waypoint \u2014 a fixed point of assistance no matter which country you are moving through." },
      { q: "Is R0AM travel insurance?", a: "R0AM by Wadiah Mutual is a travel assistance and global mobility distribution brand. Coverage and services are subject to the selected plan, terms, limits, exclusions, provider availability, and official contract wording." },
      { q: "Who is R0AM designed for?", a: "People who don't live their year in one country: digital nomads, seasonal workers, traders and conference travelers, relocation clients, international families, executives, and HNW travel groups." },
      { q: "Does R0AM cover pre-existing conditions?", a: "Where available, R0AM includes a defined benefit for pre-existing conditions, subject to limits, terms, exclusions, and the general conditions of the selected plan. We never claim full pre-existing condition coverage." },
      { q: "What is SmartBag?", a: "SmartBag is the simple entry point into R0AM. It supports travelers when luggage is delayed, lost, misrouted, mishandled, or becomes a travel disruption \u2014 subject to limits and documentation requirements." },
      { q: "Does telemedicine replace emergency care?", a: "No. Telemedicine and digital triage are support tools to help the medical team evaluate a case faster. They do not replace emergency medical services." },
      { q: "How does pricing work?", a: "Pricing is not fixed. Starting price is subject to plan, age, country of residence, destination, and terms. Request a quote and our team will build your R0AM plan." },
      { q: "How do I get started?", a: "Use the Get My Quote funnel. It takes a couple of minutes and is fully mobile-first. Leads disclosing pre-existing conditions are routed to assisted review rather than instant checkout." },
    ],
  },
};

export default en;
